import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import SeriesSelector from "../../SeriesSelector";
import { useCreateElementContext } from "../Context/CreateElementContext";
import { Add } from "@material-ui/icons";
import { getRandomId } from "../../../../utils";

const SeriesList = () => {
  const { form } = useCreateElementContext();

  const handleAddSection = () => {
    form.setFields((prev) => ({
      sequence_details: [...prev.sequence_details, { id: getRandomId() }],
    }));
  };

  const handleDelete = (index) => {
    form.setFields((prev) => ({
      sequence_details: prev?.sequence_details?.filter((_, i) => index !== i),
    }));
  };

  const onSeriesSectionChange =
    (index) =>
    ({ values, errors, detailsApi }) => {
      const sequenceDetails = form.values.sequence_details;
      sequenceDetails[index] = {
        ...values,
        languages:
          detailsApi?.data?.content?.map((item) => item.lang_code) ?? [],
      };

      form.setFields((prev) => ({
        sequence_details: [...sequenceDetails],
      }));
    };

  return (
    <Box py={2}>
      <Typography variant="h5">SERIES LIST</Typography>

      <Box>
        {form.values.sequence_details.map((item, index) => (
          <SeriesSelector
            title={`Section ${index + 1}`}
            defaultValue={item}
            key={item.id}
            onChange={onSeriesSectionChange(index)}
            onDelete={() => handleDelete(index)}
          />
        ))}
      </Box>
      <Button
        onClick={handleAddSection}
        endIcon={<Add />}
        color="error"
        sx={{ mt: 2 }}
      >
        Add section
      </Button>
    </Box>
  );
};

export default SeriesList;
